import { Store } from "../utils/Store";
export type CustomerTrackingInformation = {
	customerValidForFsd: boolean;
	customerValidForWeb: boolean;
	customerBranchCode: string;
	customerSegment: string;
	customerIsTraderFranchise: boolean;
};
type State = {
	customerInformation: Record<string, CustomerTrackingInformation | null | undefined>;
	personId?: string;
	activeContext?: string;
};

class TrackingStore extends Store {
	_state: State;

	constructor() {
		super();
		this.setEmptyState();
	}

	setEmptyState() {
		this._state = {
			customerInformation: {},
			personId: undefined,
			activeContext: undefined,
		};
	}

	setCustomerInformation(customerId: string, information: CustomerTrackingInformation | null | undefined) {
		this._state.customerInformation[customerId] = information;
	}

	setPersonId(personId: string) {
		this._state.personId = personId;
	}

	setActiveContext(activeContext: string) {
		this._state.activeContext = activeContext;
	}

	getPersonId(): string | null | undefined {
		return this._state.personId;
	}

	getActiveContext(): string | null | undefined {
		return this._state.activeContext;
	}

	getCustomerInformation(customerId: string | null | undefined): CustomerTrackingInformation | null | undefined {
		if (customerId) {
			return this._state.customerInformation[customerId];
		}

		return undefined;
	}
}

export default new TrackingStore() as TrackingStore;
